import React, { useRef, useState, useEffect } from "react";
import { getUserAuditResults } from "requests/qaCaseAudit";
import { MCard, MGrid } from "components/Shared";
import { DATA_TYPE_DATE, DATA_TYPE_TEXT_BUTTON } from "typeConstants/dataTypes";
import { filterOnFilterDate } from "components/Homeowner/History/DataFormatters";

interface QualityAssuranceAuditResultsProps {
  internetUserId: number,
  onControlNumberSelected?: (controlNumber: number) => void,
  filterDate?: Date,
}

const QualityAssuranceAuditResults = ({
  internetUserId,
  onControlNumberSelected,
  filterDate,
}: QualityAssuranceAuditResultsProps) => {
  const mounted = useRef(true);
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState(null);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    setIsFetching(true);
    setData(null);
    getUserAuditResults({ internetUserId: internetUserId, lookbackDays: 30 }, (x) => {
      setIsFetching(false);
      setData(x);
    }, mounted);
  }, [internetUserId]);

  useEffect(() => {
    if(!data) {
      setFields([]);
      return;
    }

    if(!data.length) {
      setFields([
        { key: "no-results", label: "", value: null }
      ]);
      return;
    }

    const columns = [
      { 
        key: "controlIdNumber",
        name: "Control #",
        dataSource: "controlIdNumber",
        dataType: DATA_TYPE_TEXT_BUTTON,
        tooltip: () => onControlNumberSelected ? "Click to view case" : "",
        width: 90,
      },
      { key: "customerNameNumber", name: "Customer Name", dataSource: r => `${r.customerInfo.customerName} (${r.customerInfo.customerNumber})`, width: 300 },
      { key: "surveyType", name: "Survey Type", dataSource: "surveyType", width: 300 },
      { key: "auditDate", name: "Audit Date", dataSource: "auditDate", dataType: DATA_TYPE_DATE, width: 100, },
      { key: "auditFail", name: "Results", dataSource: "result", },
    ];

    const onCellClick = (row, column) => {
      const rowItem = data[row];
      switch (column) {
        case "controlIdNumber":
          if (onControlNumberSelected) {
            onControlNumberSelected(rowItem.controlIdNumber);
          }
          break;
      }
    };

    setFields([
      {
        key: "grid",
        control: (
          <MGrid
            isFetchingData={isFetching}
            columnDefinitions={columns}
            data={data?.filter(d => filterOnFilterDate(filterDate, d.auditDate))}
            disableFilters
            onCellButtonClick={onCellClick}
          />
        )
      }
    ]);
  }, [data, filterDate]);

  return (
    <MCard
        className={"mcard-mgrid-250"}
        title="QA Case Audits"
        isFetching={isFetching}
        fields={fields}
        singleColumn
      />
  );
};

export default QualityAssuranceAuditResults;